import { Pipe, PipeTransform } from '@angular/core';

import { environment } from '../../../environments/environment';

@Pipe({
  name: 'score'
})
export class ScorePipe implements PipeTransform {

  transform(input: string, ...args: unknown[]): unknown {
      if (!input) {
        return input;
      }
      if (environment.EXAM === 'bright') {
        if (!input) {
          input = '0';
        }
        let inputString = input.toString();
        if (!inputString.includes('.')) {
          return inputString + '.0';
        }
      }

      if (environment.EXAM === 'linguaskill') {
        let inputString = parseInt(input, 10);
        if (inputString > 180) {
          return '180+';
        }
        return Math.trunc(inputString);
      }
      return input;

  }

}
